import { render, staticRenderFns } from "./Accelerator.vue?vue&type=template&id=5c65e5be&scoped=true"
import script from "./Accelerator.vue?vue&type=script&lang=js"
export * from "./Accelerator.vue?vue&type=script&lang=js"
import style0 from "./Accelerator.vue?vue&type=style&index=0&id=5c65e5be&prod&lang=less&scoped=true"
import style1 from "./Accelerator.vue?vue&type=style&index=1&id=5c65e5be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c65e5be",
  null
  
)

export default component.exports